import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MicroQualificationService from "../../services/MicroQualificationService";

let initialState = {
    partnerOrgs: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllPartnerOrganizations = createAsyncThunk(
    'getAllPartnerOrganizations',
    async ({page, limit}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await MicroQualificationService.getPartnerOrganizations(page, limit);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const partnerOrgSlice = createSlice({
    name: 'partnerOrgSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllPartnerOrganizations.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllPartnerOrganizations.fulfilled, (state, action) => {
                state.isLoading = false;
                state.partnerOrgs = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllPartnerOrganizations.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.partnerOrgs = [];
                state.hasMore = false;
            })
    }
});

export const {} = partnerOrgSlice.actions;

export default partnerOrgSlice.reducer;